import {
    PAY_FREQUENCY_LIST_YEARLY,
    PAY_FREQUENCY_LIST_MONTHLY,
    PAY_FREQUENCY_LIST_BI_WEEKLY,
    PAY_FREQUENCY_LIST_WEEKLY,
    PAY_FREQUENCY_LIST_DAILY,
    PAY_FREQUENCY_LIST_HOURLY,
    TELEWORK_LIST_COMPLETE,
    TELEWORK_LIST_PARTIAL,
    TELEWORK_LIST_NO,
    PAY_FREQUENCY_LIST_PER_JOB,
} from './constants';
import * as currencySet from './data/currency.json';
import { checkEsToken, getElasticSearchSuggestionPostFetch } from './services/appServices';
import { ELASTICSEARCH_SUGGESTION_API_URL } from './elasticSearchHelper';

import _get from 'lodash/get';
import _toUpper from 'lodash/toUpper';
import _map from 'lodash/map';
import _isNil from 'lodash/isNil';
import _parseInt from 'lodash/parseInt';
import _isNaN from 'lodash/isNaN';
import _find from 'lodash/find';
import _omit from 'lodash/omit';
import _filter from 'lodash/filter';
import _remove from 'lodash/remove';
import _sortBy from 'lodash/sortBy';
import _keys from 'lodash/keys';

export const getRaceList = () => ['American Indian', 'Alaska Native', 'Asian', 'Black or African American', 'Native Hawaiian', 'Pacific Islander', 'White'];

export const getEmploymentTypeList = () => ['Full-Time', 'Part-Time', 'Contractor', 'Contract to Hire', 'Seasonal / Temp', 'Gig-work', 'Per Diem'];

export const getSalaryRangeList = () => ['0', '20000', '40000', '60000', '80000', '100000', '120000'];

export const getEducationList = () => [
    'Some High School',
    'GED or High School Equivalency',
    'High School Diploma',
    'Some College',
    "Associate's Degree",
    'Bachelor’s Degree',
    'Master’s Degree',
    'Doctorate',
];

// export const getYearsOfExperienceList = () => ['0 Years', 'Under 1 Year', '1+ Years', '2+ Years', '3+ Years', '4+ Years', '5 Years'];
export const getYearsOfExperienceOptions = () => [
    {
        description: '0 Years',
        minVal: 0,
        maxVal: 0,
    },
    {
        description: 'Under 1 Year',
        minVal: 1,
        maxVal: 11,
    },
    {
        description: '1+ Years',
        minVal: 12,
        maxVal: 23,
    },
    {
        description: '2+ Years',
        minVal: 24,
        maxVal: 35,
    },
    {
        description: '3+ Years',
        minVal: 36,
        maxVal: 47,
    },
    {
        description: '4+ Years',
        minVal: 48,
        maxVal: 59,
    },
    {
        description: '5 Years',
        minVal: 60,
        maxVal: 60,
    },
];

export const getPayFrequencyList = () => [
    PAY_FREQUENCY_LIST_YEARLY,
    PAY_FREQUENCY_LIST_MONTHLY,
    PAY_FREQUENCY_LIST_BI_WEEKLY,
    PAY_FREQUENCY_LIST_WEEKLY,
    PAY_FREQUENCY_LIST_DAILY,
    PAY_FREQUENCY_LIST_HOURLY,
    PAY_FREQUENCY_LIST_PER_JOB,
];

export const getTeleworkList = () => [TELEWORK_LIST_COMPLETE, TELEWORK_LIST_PARTIAL, TELEWORK_LIST_NO];

export const getReasonLov = () => [
    'The software does not meet our business needs.',
    'The value provided is not worth the price.',
    'The software is not user friendly / very difficult to use.',
    'Other',
];

// export const getGenderList = () => ['Male', 'Female', 'Non-binary', 'Transgender', 'Intersex']

export const getOtherEducationList = () => [
    'AWS Certified DevOps Engineer Pro',
    'AWS Certified Solution Architect Pro',
    'AWS Certified Database Specialist',
    'Certified Culinarian',
    'Certified Executive Chef',
    'Electric Meter Removal Certification',
];

// export const getIndustryList = () => [
//     'Aerospace',
//     'Agriculture',
//     'Arts',
//     'Automotive',
//     'Construction',
//     'Education',
//     'Electronics',
//     'Energy',
//     'Entertainment',
//     'Finance',
//     'Food',
//     'Health Care',
//     'Hospitality',
//     'Information Technology',
//     'Law Enforcement',
//     'Legal',
//     'Manufacturing',
//     'Mining',
//     'Music',
//     'News Media',
//     'Pharmaceutical',
//     'Real Estate',
//     'Sports / Athletic',
//     'Telecommunications',
//     'Transport',
// ];

// export const getCompanySizeList = () => ['1 to 10', '11 to 50', '51 to 100', '100 +', '300 +', '500 +', '1000 +', '2000 +', '5000 +', '10000 +'];
export const getCompanySizeOptions = () => [
    {
        description: '1 to 10 Employees',
        minVal: 1,
        maxVal: 10,
    },
    {
        description: '11 to 50 Employees',
        minVal: 11,
        maxVal: 50,
    },
    {
        description: '51 to 100 Employees',
        minVal: 51,
        maxVal: 99,
    },
    {
        description: '100+ Employees',
        minVal: 100,
        maxVal: 299,
    },
    {
        description: '300+ Employees',
        minVal: 300,
        maxVal: 499,
    },
    {
        description: '500+ Employees',
        minVal: 500,
        maxVal: 999,
    },
    {
        description: '1,000+ Employees',
        minVal: 1000,
        maxVal: 1999,
    },
    {
        description: '2,000+ Employees',
        minVal: 2000,
        maxVal: 4999,
    },
    {
        description: '5,000+ Employees',
        minVal: 5000,
        maxVal: 9999,
    },
    {
        description: '10,000+ Employees',
        minVal: 10000,
    },
];

// export const getDateFormatOptions = () => [
//     { code: 'MM/dd/yyyy', description: 'MM/DD/CCYY' },
//     { code: 'dd/MM/yyyy', description: 'DD/MM/CCYY' },
// ];
export const getDateFormatOptions = () => [
    { code: 'MM/dd/yyyy', description: 'MM/DD/CCYY' },
    { code: 'dd/MM/yyyy', description: 'DD/MM/CCYY' },
];

export const getTimeFormatOptions = () => [
    { code: 'h:mm a', description: '12H (AM/PM)' },
    { code: 'HH:mm', description: '24H' },
];

export const mapCreatableLovOptionToValue = option => {
    if (_isNil(option)) {
        return null;
    } else {
        return option?.inputValue ? option.inputValue : option;
    }
};

export const mapCreatableLovOptionsToValueList = ({ options = [] }) => {
    if (_isNil(options) || options.length === 0) {
        return null;
    } else {
        return _map(options, option => (option?.inputValue ? option.inputValue : option));
    }
};

export const lovOptionToValue = ({ option, isUpper, isInt }) => {
    if (_isNil(option)) {
        return null;
    } else {
        if (isInt) {
            const intValue = _parseInt(_get(option, 'value'));
            return _isNaN(intValue) ? 0 : intValue;
        } else {
            const newValue = _get(option, 'inputValue');
            const optionValue = newValue !== undefined ? newValue : _get(option, 'value');
            return isUpper ? _toUpper(optionValue) : optionValue;
        }
    }
};

// export const mapCreatableLovOptionsToValueList = ({ options = [], isUpper, isInt }) => {
//     if (_isNil(options) || options.length === 0) {
//         return null;
//     } else {
//         return _map(options, option => {
//             if (isInt) {
//                 const intValue = _parseInt(_get(option, 'value'));
//                 return _isNaN(intValue) ? 0 : intValue;
//             } else {
//                 const newValue = _get(option, 'inputValue');
//                 const optionValue = newValue !== undefined ? newValue : _get(option, 'value');
//                 return isUpper ? _toUpper(optionValue) : optionValue;
//             }
//         });
//     }
// };

export const valueListToLovOptions = ({ lov, valueList = [] }) => {
    if (_isNil(valueList) || valueList.length === 0) {
        return [];
    } else {
        return _map(valueList, value => {
            const option = _find(lov, item => item.value === value);
            return option ? option : { value, label: value };
        });
    }
};

export const valueToLovOption = ({ lov, value }) => {
    if (_isNil(value)) {
        return null;
    } else {
        const option = _find(lov, item => item.value === value);
        return option ? option : { value, label: value };
    }
};

export const getNewLovOption = option => {
    return option?.inputValue;
};

export const getNewLovOptions = (options = []) => {
    return _map(
        _filter(options, option => option?.inputValue),
        option => option.inputValue,
    );
};

export const isNewLovOption = option => {
    return !!option?.inputValue;
};

export const getCurrentJsEngagedCount = (jobId, engageList, limit) => {
    // console.log({ jobId, engageList, limit });
    return limit - engageList.filter(el => el.jobId === jobId).length;
};

/**
 * Sort by alphabetical order and put U.S. and Canada at the top.
 *
 * @param {*} options
 */
export const sortCountryLov = options => {
    let sortedOptions = _sortBy(options, 'name');
    const usOptions = _remove(sortedOptions, o => o.name === 'United States');
    const canadaOptions = _remove(sortedOptions, o => o.name === 'Canada');
    return [...usOptions, ...canadaOptions, ...sortedOptions];
};

export const getCurrencyList = () => {
    return _map(_keys(currencySet.default), code => currencySet.default[code]);
};

export const getTierTitle = val => {
    switch (val) {
        case 1:
            return 'Active (Tier 1)';
        case 2:
            return 'Emerging Growth (Tier 2)';
        case 3:
            return 'Global (Tier 3)';
        default:
            return '';
    }
};

export const getTierDetailsList = val => {
    switch (val) {
        case 1:
            return [
                'Unlimited Candidate Resume Views',
                'Post 3 ‘Active’ Jobs Simultaneously',
                'Engage with 20 unique candidates for each Job Listing',
                '1 user seat (account login)',
                'Basic company Brand Page',
            ];
        case 2:
            return [
                'Unlimited Candidate Resume Views',
                'Post 7 ‘Active’ Jobs Simultaneously',
                'Engage with 60 unique candidates for each Job Listing',
                '3 user seats (account logins)',
                'Internal chat with your team. Never miss a beat!',
                'Full company Brand Page',
            ];
        case 3:
            return [
                'Unlimited Candidate Resume Views',
                'Post Unlimited Jobs Simultaneously',
                'Unlimited candidate engagement for each Job Listing',
                '10 user seats (account logins)',
                'Internal chat with your team. Never miss a beat!',
                'Full Company Branding with consolidated job listings page',
                'Verified ‘Global’ Account Badge –Exclusive benefit to Tier 3 Plans',
                'Additional seats can be purchased at $99 per month / per seat',
            ];
        default:
            return [];
    }
};

export const getTiersLov = val => {
    switch (val) {
        case 2:
            return ['Tier 1'];
        case 3:
            return ['Tier 2', 'Tier 1'];
        default:
            return [];
    }
};

//--------------------------------------------------------------------------
// Gender LOV Suggestion
//--------------------------------------------------------------------------
export const getCreatableLovSuggestions = async ({ type, keywords, esToken, setEsToken }) => {
    // const db = getFirestore();

    let checkedEsToken = null;
    try {
        checkedEsToken = await checkEsToken(esToken);
    } catch (error) {
        console.log('Failed checking token', error);
    }

    try {
        if (checkedEsToken) {
            const esResp = await getElasticSearchSuggestionPostFetch({
                url: ELASTICSEARCH_SUGGESTION_API_URL,
                type,
                queryObject: { name: keywords },
                token: checkedEsToken.token,
            });

            if (checkedEsToken.isNew) {
                setEsToken(_omit(checkedEsToken, 'isNew'));
            }

            const result = _get(esResp, 'result', []);
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', { result });

            return _map(result, item => item?.name);
        }

        return [];
    } catch (error) {
        console.log('Transaction failed: ', error);
    }
};
